import script from "./parental.vue?vue&type=script&setup=true&lang=js"
export * from "./parental.vue?vue&type=script&setup=true&lang=js"

import "./parental.vue?vue&type=style&index=0&id=08473934&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08473934"]])

export default __exports__